import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {CustomerDataDTO} from '../../../DTOs';
import {Country, State, Title} from '../../../Models';
import {mapGetters} from 'vuex';
import {SalutationEnum, TitleEnum} from '../../../Enums';

@Component({
  computed: {
    ...mapGetters({
      userLanguage: 'getUserLanguage',
    }),
  },
})
export default class CustomerData extends Vue {
  @Prop({type: CustomerDataDTO, required: true}) customerDataDTO: CustomerDataDTO | undefined;
  @Prop({required: true}) countries: Array<Country> | undefined;
  @Prop({required: true}) titles: Array<Title> | undefined;
  @Prop({required: true}) states: { [key: number]: Array<State> } | undefined;
  @Prop({
    required: false,
    default: () => {
      return false;
    },
  }) isBilling: boolean | undefined;

  // from computed mapGetters
  private userLanguage!: string;

  get salutationDisplay() {
    let salutationDisplay = '';
    switch (this.customerDataDTO?.salutation) {
      case SalutationEnum.NONE.value:
        salutationDisplay = SalutationEnum.NONE.title[this.userLanguage];
        break;
      case SalutationEnum.MALE.value:
        salutationDisplay = SalutationEnum.MALE.title[this.userLanguage];
        break;
      case SalutationEnum.FEMALE.value:
        salutationDisplay = SalutationEnum.FEMALE.title[this.userLanguage];
        break;
      default:
        break;
    }
    return salutationDisplay;
  }

  get isGermany() {
    if (this.countries) {
      const country = this.countries.find(c => c.id === this.customerDataDTO?.country);
      if (country) {
        return country.iso31661alpha2 === 'de';
      }
      return false;
    }
    return false;
  }

  get titleDisplay() {
    let titleDisplay = '';
    if (this.customerDataDTO?.title && this.titles) {
      titleDisplay = this.titles.find(t => t.id === this.customerDataDTO?.title)?.title || titleDisplay;
    }
    return titleDisplay;
  }

  get stateDisplay() {
    let title = '';
    if (this.states && this.customerDataDTO && this.customerDataDTO.country && this.states[this.customerDataDTO.country]) {
      const state = this.states[this.customerDataDTO.country].find(s => s.id === this.customerDataDTO?.state);
      if (state) {
        title = state.title;
      }
    }
    return title;
  }

  get countryDisplay() {
    let title = '';
    if (this.countries) {
      const country = this.countries.find(c => c.id === this.customerDataDTO?.country);
      if (country) {
        if (this.userLanguage === 'en') {
          title = country.title;
        }

        if (country.translations && country.translations[this.userLanguage]) {
          title = country.translations[this.userLanguage].title;
        }
      }
      return title;
    }
  }
}
